export default __webpack_public_path__ + "static/Scroll-Image---Above-Ground-Pool-Removal-bda354231c8e58432e424eecd1de417b.jpg";